/**
 * Obtiene un mensaje de error legible desde un valor desconocido (catch o respuesta).
 * Type-safe: usa unknown en lugar de any.
 * @param defaultMessage - Mensaje por defecto si no se puede extraer uno del error (opcional).
 */
export function getErrorMessage(error: unknown, defaultMessage = 'Error inesperado'): string {
  if (error instanceof Error) return error.message || defaultMessage;
  if (typeof error === 'string') return error;
  if (error != null && typeof error === 'object' && 'message' in error && typeof (error as { message: unknown }).message === 'string') {
    return (error as { message: string }).message;
  }
  return String(error ?? defaultMessage);
}

/** Obtiene la propiedad `code` de un error (ej. código Postgres/Supabase). */
export function getErrorCode(error: unknown): string | undefined {
  if (error != null && typeof error === 'object' && 'code' in error && typeof (error as { code: unknown }).code === 'string') {
    return (error as { code: string }).code;
  }
  return undefined;
}

/** Obtiene la propiedad `status` numérica de un error (ej. HTTP 429). */
export function getErrorStatus(error: unknown): number | undefined {
  if (error != null && typeof error === 'object' && 'status' in error && typeof (error as { status: unknown }).status === 'number') {
    return (error as { status: number }).status;
  }
  return undefined;
}

/** Obtiene la propiedad `name` de un error (ej. DOMException: NotAllowedError). */
export function getErrorName(error: unknown): string | undefined {
  if (error instanceof Error) return error.name;
  if (error != null && typeof error === 'object' && 'name' in error && typeof (error as { name: unknown }).name === 'string') {
    return (error as { name: string }).name;
  }
  return undefined;
}
